module.exports = __webpack_public_path__ + "media/images/flags/32/GoSquared-b444ada8b9e430a92befe7c04f9a0332.png";